import React from 'react';

const RSSTwentySeventeenCard = (props) => {

    return (

        <article className="card events">

        	<div className="visual">

    			<div className="image">

    				<a href={props.link} target="_blank">

                        <img src={props.image} />

                    </a>

    			</div>

        	</div>

            <div className="context">

		        <a href={props.link} target="_blank">

			        <div className="content">

				        <h5 dangerouslySetInnerHTML={{__html: props.title}}></h5>

			        </div>

		        </a>

	        </div>

        </article>

    );

}

export default RSSTwentySeventeenCard;
